import axiosInstance from "../../../interceptor/intercetptor-inctence";

export const getUnitList = (formData) => {
    return axiosInstance.post(`api/units/list`, formData);
}

export const statusUnit = (id) => {
    return axiosInstance.post(`api/units/status?unitId=${id}`,{});
}

export const deleteUnit = (id) => {
    return axiosInstance.post(`api/units/delete?unitId=${id}`,{});
}

export const addUnit = (formData) => {
    return axiosInstance.post(`api/units/add`,formData);
}

export const updateUnit = (formData) => {
    return axiosInstance.post(`api/units/update`,formData);
}

export const getUnitMasterList = () => {
    return axiosInstance.post(`api/units/master`, {});
}

export const getGlobalUnitList = () => {
    return axiosInstance.post(`api/global-master/unit_master`, {});
}

export const addGlobalUnit = (formData) => {
    return axiosInstance.post(`api/global-master/import_unit_master`, formData);
}
